module.exports = function stripTags(text){
    return text.replace(/<\/?(p|span|em|strong|u)\b[^>]*>/gi, '');
}